var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('svg',{attrs:{"viewBox":"0 0 80 80"}},[_c('circle',{attrs:{"cx":"40","cy":"40","r":"35"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }